import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { withStyles } from 'material-ui/styles';
import Typography from "material-ui/Typography";
import Wrapper from '../common/Wrapper';
import Button from '../../Parts/Button.jsx';

const styles = () => ({
  main: {
    textAlign: 'center',
  },
});

class Thankyou extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <Wrapper>
        <div className={classes.main}>
          <Typography variant="subheading">アンケート調査にご協力いただきありがとうございました。</Typography>
          <Typography variant="subheading">入力されました内容はサービスの改善に役立てさせていただきます。</Typography>
          <Typography variant="subheading">ご不明な点がございましたら画面右下のチャットよりお問い合わせください。</Typography>
          <Button
            text="ホームへ戻る"
            handleClickButton={this.props.goToDashboard}
            style={{ margin: '40px auto', width: 250 }}
          />
        </div>
      </Wrapper>
    )
  }
}

Thankyou.propTypes = {
  classes: PropTypes.object.isRequired,
  goToDashboard: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToDashboard: () => dispatch(push("/")),
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(Thankyou));


// WEBPACK FOOTER //
// ./src/components/Questionnaire/pages/Thankyou.jsx